import { BaseModel } from "./BaseModel";

export class Action extends BaseModel {
  schema = "/action";
  constructor(params) {
    return super(params, "/action");
  }
}
